export const IN_STOCK = "IN_STOCK"
export const OUT_OF_STOCK = "OUT_OF_STOCK"
export const ON_BACKORDE = "ON_BACKORDER"
